import { Component, OnInit } from '@angular/core';
import { SummaryReportsService } from '../../services/reports/summary-reports.service';
import { IBrandPassEnrollmentStats } from '../../interfaces/brand-pass-enrollment-stats';
import { PortalUserService } from '../../services/admin/portal-user.service';
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { IBrandPassEnrollmentStatsArtifact } from '../../interfaces/artifacts/brand-pass-emrollment-stats';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-enrollment-report',
  standalone: false,
  templateUrl: './enrollment-report.component.html',
  styleUrls: ['./enrollment-report.component.css']
})
export class EnrollmentReportComponent implements OnInit {

  envRegions = [];
  enrollmentStats: IBrandPassEnrollmentStats[] = [];
  enrollments = new Array<IBrandPassEnrollmentStatsArtifact>();
  cols: any[] = [];
  selectedBrand!: string;
  hideSpinner: boolean = true;
  hideTable: boolean = true;

  totalUniqueAccounts: number = 0;
  totalLast30AddsCnt: number = 0;
  totalLast30Removes: number = 0;
  totalLast30Nets: number = 0;
  totalAllPassRegisters: number = 0;
  emailAddress!: string;

  constructor(
    private summaryReportsService: SummaryReportsService,
    private portalUserService: PortalUserService,
    private tokenStorageService: TokenStorageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    // this.cols = [
    //   { field: 'brandCode', header: 'Brand Code', display: 'table-cell', width:'8%'  },
    //   { field: 'description', header: 'Brand Description', display: 'table-cell', width:'17%'  },
    //   { field: 'passName', header: 'Pass Name', display: 'table-cell', width:'20%'  },
    //   { field: 'uniqueAccountsCnt', header: 'Active Accounts', display: 'table-cell', width:'11%'  },
    //   { field: 'last30AddsCnt', header: 'Last 30 Day Adds', display: 'table-cell', width:'11%'  },
    //   { field: 'last30RemovesCnt', header: 'Last 30 Day Removes', display: 'table-cell', width:'11%'  },
    //   { field: 'last30NetsCnt', header: 'Last 30 Day Nets', display: 'table-cell', width:'11%'  },
    //   { field: 'allPassRegistersCnt', header: 'Total Registered Passes', display: 'table-cell', width:'11%'  }
    // ]; 
    var currentUserValue = this.tokenStorageService.getCurrentUser();
      if (currentUserValue != null) {
        var userName = currentUserValue.userName;
        this.portalUserService.getUserEmailAddress(userName)
        .subscribe(result => {
            this.emailAddress = result; 
        });
      }

    this.cols = [
      { field: 'brandCode', header: 'Brand Code', display: 'table-cell', width:'9%'  },
      { field: 'brandDescription', header: 'Brand Description', display: 'table-cell', width:'18%'  },
      { field: 'passName', header: 'Pass Name', display: 'table-cell', width:'20%'  },
      { field: 'activeAccounts', header: 'Active Accounts', display: 'table-cell', width:'12%'  },
      { field: 'last30DayAdds', header: 'Last 30 Day Adds', display: 'table-cell', width:'15%'  },
      { field: 'last30DayRemoves', header: 'Last 30 Day Removes', display: 'table-cell', width:'15%'  },
      { field: 'last30DayNets', header: 'Last 30 Day Nets', display: 'table-cell', width:'13%'  },
    ]; 
    this.getPortalEnrollmentStats();
  }

  getPortalEnrollmentStats() {
    this.hideSpinner = false;
    this.hideTable = true;
    //if email feture is required then we can pass the email address this.emailAddress
    this.summaryReportsService.getPortalEnrollmentStats('')
    .subscribe({
      next: (response) => {
        let result : IBrandPassEnrollmentStatsArtifact[] = JSON.parse( response.responseData);
        this.totalUniqueAccounts = 0;
        this.totalLast30AddsCnt = 0;
        this.totalLast30Removes = 0;
        this.totalLast30Nets = 0;
        this.totalAllPassRegisters = 0;
        result.forEach(element => {
          this.totalUniqueAccounts += Number.parseInt( element.activeAccounts);
          this.totalLast30AddsCnt +=  Number.parseInt(element.last30DayAdds);
          this.totalLast30Removes +=  Number.parseInt(element.last30DayRemoves);
          this.totalLast30Nets +=  Number.parseInt(element.last30DayNets);
          // this.totalAllPassRegisters += element.allPassRegistersCnt;
        })
        console.log("Total Unique Accounts: " + this.totalUniqueAccounts);
        // Sort by brandDescription (case-insensitive)
        result.sort((a, b) => a.brandDescription.localeCompare(b.brandDescription, undefined, { sensitivity: 'base' }));

        this.enrollments = result;
        this.hideSpinner = true;
        this.hideTable = false;
      },
      error: (error) => {
        this.hideSpinner = true;
        this.alertTheUser("Error", "Unable to run the report.");
      },
      complete: () => {
      }
    });
  }

  alertTheUser(header: string, message: string) {
    this.confirmationService.confirm({
      message: message,
      header: header,
      key: 'enrollment-artifact',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: "Ok",
      rejectVisible: false,
      acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
      accept: () => {
         return;
       }
    });
  }

}
